export default {
  DEFAULT: 'DefaultLayout',
  AUTH: 'AuthLayout'
}
